"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIMEDOUT = exports.HISTORY_CHANGED = exports.MARKER_UNMOUNTED = exports.MARKER_MOUNTED = void 0;
var MARKER_MOUNTED = 'MARKER_MOUNTED';
exports.MARKER_MOUNTED = MARKER_MOUNTED;
var MARKER_UNMOUNTED = 'MARKER_UNMOUNTED';
exports.MARKER_UNMOUNTED = MARKER_UNMOUNTED;
var HISTORY_CHANGED = 'HISTORY_CHANGED';
exports.HISTORY_CHANGED = HISTORY_CHANGED;
var TIMEDOUT = 'TIMEDOUT';
exports.TIMEDOUT = TIMEDOUT;